import React from 'react';
import './App.scss';
import Routes from './Route/Routes';
function App() {
  return (
    <>
      <Routes/>
    </>
  );
}

export default App;
